import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id CA24758C-3B0C-44DE-9395-C5CAF2981E5D
 * name star-minus
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-minus.svg
 * tags
 * - Shape 
 */
export const StarMinusIcon = createSvgIcon(<><path d="M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M14 17V19H22V17H14Z" /></>, 'StarMinusIcon');
export default StarMinusIcon